<template>
  <sections-extra-layout>
    <template slot="title">Content</template>
    <template slot="description">Define the content of the survey</template>
    <template slot="content">
      <p class="font-bold mb-4">The question of the survey will be the following one:</p>
      <div class="container">
        <div class="flex flex-col items-start">
          <label v-for="lang in languages" :key="lang" class="cursor-pointer w-full mb-2 inline-flex">
            <span class="ml-2 inline-block mt-3.5">{{ lang }}</span>
            <ValidationProvider mode="lazy" rules="required" v-slot="{ errors }" class="w-full md:w-3/4 mb-4" name="question">
              <input
                v-model="localQuestion[lang]"
                placeholder="How likely are you to recommend our service to a friend or colleague?"
                class="mx-4 px-3 py-3
                placeholder-gray-400
                text-gray-700
                relative
                bg-white
                bg-white
                rounded
                text-sm
                shadow
                outline-none
                focus:outline-none
                focus:shadow-outline
                w-full"
                @change="emitQuestion"
                >
              <span class="text-red-500 font-bold m-4">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>
        </div>
      </div>
    </template>
  </sections-extra-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Content',
  props: {
    question: Object
  },
  data() {
    return {
      localQuestion: this.question,
      error: {}
    }
  },
  computed: {
    ...mapGetters('account', {
      defaultLang: 'defaultLang',
      site: 'currentSite'
    }),
    languages () {
      return this.site.languages.map(lang => lang.lang)
    }
  },
  methods: {
    initErrorObject() {
      let errorObject = {}
      for (let lang of this.languages) {
        errorObject[lang] = {
          status: false,
          message: null
        }
      }
      return errorObject
    },
    emitQuestion() {
      this.$emit('update-question', this.localQuestion)
    }
  },
  watch: {
    question: {
      handler(val) {
        this.localQuestion = { ...val }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.error = this.initErrorObject();
    if (!this.question || !this.localQuestion) {
      this.localQuestion = {}
      for (let lang of this.languages) {
        this.localQuestion[lang] = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/surveys/ui/form/content.vue